import React from 'react'
import ed from '../assets/ed.png';
import mau from '../assets/mau.png';


const Team = () => {
    return (
        <div className='team flex centerflex vertcenter secPad relative'>
            <div className="container-lg flex flexcol vertcenter relative">
                <h2>The Team</h2>
                <div className="flex flexrow space flexwrap">
                    <div className="cardTeam ed relative">
                        <span className="player">P1</span>
                        <img src={ed} alt="Ed" />
                        <h4>ED - BPG</h4>
                        <span>Co - Founder</span>
                    </div>
                    <div className="cardTeam mau relative">
                        <span className="player">P2</span>
                        <img src={mau} alt="MJ" />
                        <h4>MJ - BPG</h4>
                        <span>Co - Founder</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team
